import React from 'react'

import eMozartLogoFull from '@/assets/emozart-logo-full.png'
import eMozartLogoIcon from '@/assets/emozart-logo-icon.png'
import { cn } from '@/utils/cn'

interface LogoProps {
  variant?: 'full' | 'icon'
  className?: string
}

export const Logo: React.FC<LogoProps> = ({ variant = 'full', className }) => {
  if (variant === 'icon') {
    return (
      <img
        src={eMozartLogoIcon}
        alt="eMozart"
        className={cn('h-8 w-8', className)}
        role="presentation"
        onError={(e) => {
          // Fallback to PNG if SVG fails
          const target = e.target as HTMLImageElement
          if (target.src.endsWith('.svg')) {
            target.src = eMozartLogoIcon
          }
        }}
      />
    )
  }

  return (
    <img
      src={eMozartLogoFull}
      alt="eMozart Assessment Platform"
      className={cn('h-10 w-auto', className)}
      role="presentation"
      onError={(e) => {
        // Fallback to PNG if SVG fails
        const target = e.target as HTMLImageElement
        if (target.src.endsWith('.svg')) {
          target.src = eMozartLogoFull
        }
      }}
    />
  )
}
